import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import { Field } from '@/types/fields';

interface Props {
  readonly title: string;
  readonly fields: readonly Field<any /* The specific field type is irrelevant */>[];
}

export const ListFormFieldTitle: React.FC<Props> = (props: Props): React.ReactElement => {
  const { title, fields } = props;

  if (fields.length === 1) {
    return (
      <Box mb={2}>
        <Typography variant="subtitle1">{title}</Typography>
      </Box>
    );
  }

  return <></>;
};
